<template>
  <div class="login-wrap">
    <!-- 未登录：只显示登录框 -->
    <div v-if="!token" class="login-box">
      <div class="login-header">
        <div class="login-icon">📊</div>
        <h2>管理面板</h2>
        <p>请登录以继续</p>
      </div>
      <el-input 
        v-model="username" 
        placeholder="请输入账号" 
        prefix-icon="el-icon-user"
        class="login-input"
      ></el-input>
      <el-input 
        v-model="password" 
        placeholder="请输入密码" 
        type="password" 
        prefix-icon="el-icon-lock"
        class="login-input"
        @keyup.enter="login"
      ></el-input>
      <el-button type="primary" @click="login" :loading="loginLoading" class="login-btn">登录</el-button>
      
      <!-- 注册入口 -->
      <!-- <div class="register-link">
        没开放注册
      </div> -->
    </div>

    <!-- 已登录：显示提交 + 历史 -->
    <div v-else class="manage-box">
      <!-- 顶部导航栏 -->
      <div class="nav-bar">
        <el-button 
          icon="el-icon-back" 
          @click="goBack" 
          class="back-btn"
          size="medium"
        >返回首页</el-button>
        <div class="nav-title">数据管理面板</div>
        <div class="nav-right">
          <el-button @click="logout">退出登录</el-button>
        </div>
      </div>

      <!-- 数据提交卡片 -->
      <div class="card submit-card">
        <div class="card-header">
          <span class="card-title">{{ isEditing ? '✏️ 编辑数据' : '📝 提交数据！更新明日价格，日期改到后一天！' }}</span>
          <el-tag v-if="isEditing" type="warning" size="small" effect="dark">编辑模式</el-tag>
        </div>

        <!-- 渠道选择：小刀 / 星月 / GBO -->
        <el-radio-group v-model="currentChannel" class="channel-group" :disabled="isEditing" style="margin-bottom:15px">
          <el-radio label="xiaodao">小刀</el-radio>
          <el-radio label="xingyue">星月</el-radio>
          <el-radio label="gbo">GBO</el-radio>
        </el-radio-group>

        <!-- 内容 -->
        <el-input
          v-model="content"
          type="textarea"
          :rows="3"
          :placeholder="getPlaceholder()"
          class="content-textarea"
        ></el-input>

        <!-- 格式提示 -->
        <div class="format-tip">
          <i class="el-icon-info"></i>
          <span>格式要求：必须跟通道名保持一致才能正确导出账单！</span>
        </div>

        <!-- 日期 + 时间 分开选择 -->
        <div class="datetime-group">
          <el-date-picker
            v-model="selectDate"
            type="date"
            :clearable="false"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            prefix-icon="el-icon-date"
            @change="onDateChange"
            class="datetime-picker"
          ></el-date-picker>

          <el-time-picker
            v-model="selectTime"
            type="time"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="选择时间"
            prefix-icon="el-icon-time"
            class="datetime-picker"
          >
          </el-time-picker>
        </div>

        <!-- 按钮组 -->
        <div class="button-group">
          <el-button 
            v-if="!isEditing" 
            type="primary" 
            @click="submit" 
            :loading="submitLoading"
            class="action-btn"
          >
            提交{{ getChannelName() }}
          </el-button>
          <template v-else>
            <el-button type="success" @click="saveEdit" :loading="submitLoading" class="action-btn">保存修改</el-button>
            <el-button @click="cancelEdit" class="action-btn">取消</el-button>
          </template>
        </div>
      </div>

      <!-- 历史记录卡片 -->
      <div class="card history-card">
        <div class="card-header">
          <span class="card-title">📋 历史记录</span>
          <el-date-picker
            v-model="searchDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="按日期查询"
            size="small"
            :clearable="false"
            class="search-date-picker"
            @change="getHistory"
          ></el-date-picker>
        </div>

        <!-- 三TAB：小刀 / 星月 / GBO -->
        <el-tabs v-model="activeTab" @tab-click="getHistory" style="margin-bottom:15px">
          <el-tab-pane label="小刀" name="xiaodao" />
          <el-tab-pane label="星月" name="xingyue" />
          <el-tab-pane label="GBO" name="gbo" />
        </el-tabs>

        <!-- 加载状态 -->
        <div v-loading="historyLoading" class="history-list">
          <template v-if="!historyLoading && currentTabList.length === 0">
            <div class="empty-state">
              <div class="empty-icon">📭</div>
              <div class="empty-text">{{ searchDate ? '当天没有数据' : '暂无历史数据' }}</div>
              <div class="empty-hint">试试提交第一条数据吧</div>
            </div>
          </template>

          <template v-else>
            <div 
              v-for="item in currentTabList" 
              :key="item.id" 
              class="history-item"
              :class="{ 'edit-highlight': editId === item.id }"
            >
              <div class="history-content">{{ item.content }}</div>
              <div style="width:100%;font-size:12px;color:#909399">
                渠道：{{ getChannelName(item.channel) }}
              </div>
              <div class="history-time">
                <i class="el-icon-date"></i> {{ formatDate(item.submit_date) }}
                <i class="el-icon-time" style="margin-left: 12px;"></i> {{ formatTime(item.submit_time) }}
              </div>
              <div class="history-actions">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="toEdit(item)"
                  title="编辑"
                ></el-button>
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  circle
                  @click="handleDelete(item)"
                  :loading="deleteLoading === item.id"
                  title="删除"
                ></el-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 注册对话框 -->
    <el-dialog title="注册新账号" :visible.sync="showRegisterDialog" width="400px" center>
      <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
        <el-form-item label="用户名" prop="username">
          <el-input 
            v-model="registerForm.username" 
            placeholder="3-20个字符"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input 
            v-model="registerForm.password" 
            type="password" 
            placeholder="至少6位"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input 
            v-model="registerForm.confirmPassword" 
            type="password" 
            placeholder="请再次输入密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input 
            v-model="registerForm.email" 
            placeholder="选填"
            prefix-icon="el-icon-message"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRegisterDialog = false">取消</el-button>
        <el-button type="primary" @click="handleRegister" :loading="registerLoading">注册</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="showChangePasswordDialog" width="400px" center>
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input 
            v-model="passwordForm.oldPassword" 
            type="password" 
            placeholder="请输入原密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input 
            v-model="passwordForm.newPassword" 
            type="password" 
            placeholder="至少6位"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmNewPassword">
          <el-input 
            v-model="passwordForm.confirmNewPassword" 
            type="password" 
            placeholder="请再次输入新密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChangePasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="handleChangePassword" :loading="changePasswordLoading">确认修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

// 标签映射数组
const LABEL_MAP = ['x', 'x1', 'xx', 'x2','x5','速额', '怪额', '微', '微1', 'V50', 'V10起']

// 获取今天日期 YYYY-MM-DD
function getToday() {
  const date = new Date()
  const y = date.getFullYear()
  const m = (date.getMonth() + 1).toString().padStart(2, '0')
  const d = date.getDate().toString().padStart(2, '0')
  return `${y}-${m}-${d}`
}

export default {
  name: "UserLoginPage",
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    
    const validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    
    return {
      activeTab: 'xiaodao',
      // 存储全部数据：三渠道
      allHistory: { xiaodao: [], xingyue: [], gbo: [] },
      username: '',
      password: '',
      token: '',
      loginLoading: false,
      
      content: '',
      selectDate: getToday(),
      selectTime: '',
      
      // 当前渠道
      currentChannel: 'xiaodao',
      
      searchDate: getToday(),
      historyLoading: false,
      
      editId: 0,
      editChannel: '',
      submitLoading: false,
      
      deleteLoading: null,
      
      labelCount: LABEL_MAP.length,
      
      showRegisterDialog: false,
      registerLoading: false,
      registerForm: {
        username: '',
        password: '',
        confirmPassword: '',
        email: ''
      },
      registerRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      
      showChangePasswordDialog: false,
      changePasswordLoading: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        confirmNewPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateNewPass, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isEditing() {
      return this.editId !== 0
    },
    currentTabList() {
      return this.allHistory[this.activeTab] || []
    }
  },
  mounted() {
    this.checkCopyCompatibility()
    const t = localStorage.getItem('token')
    const storedUsername = localStorage.getItem('username')
    if (t) {
      this.token = t
      if (storedUsername) {
        this.username = storedUsername
      }
      this.getHistory()
    }
  },
  
  methods: {
    checkCopyCompatibility() {
      const isClipboardSupported = navigator.clipboard && window.isSecureContext
      const isExecCommandSupported = document.queryCommandSupported && document.queryCommandSupported('copy')
      
      if (!isClipboardSupported && !isExecCommandSupported) {
        console.warn('当前浏览器不支持复制功能')
        // 可选：给用户一个提示
        // this.$message.warning('当前浏览器复制功能受限，如无法复制请手动选择复制')
      }
    },
    // 获取渠道中文名称
    getChannelName(channel = this.currentChannel) {
      const map = {
        xiaodao: '小刀',
        xingyue: '星月',
        gbo: 'GBO'
      }
      return map[channel] || channel
    },
    onDateChange() {
      if (!this.isEditing) {
        this.selectTime = '00:00'
      }
    },
    // 输入框提示文字
    getPlaceholder() {
      if (this.currentChannel === 'xiaodao') return '请注意！！这是小刀小刀小刀价格'
      if (this.currentChannel === 'xingyue') return '请注意！！这是星月星月星月价格'
      if (this.currentChannel === 'gbo') return '请注意！！这是GBO GBO GBO价格'
      return '请输入内容'
    },
    
    validateContent(content) {
      if (!content || content.trim() === '') {
        return { valid: false, message: '内容不能为空' }
      }
      return { valid: true, message: '格式正确' }
    },
    
    goBack() {
      this.$router.push('/')
    },
    
    handleCommand(command) {
      if (command === 'logout') {
        this.logout()
      } else if (command === 'changePassword') {
        this.showChangePasswordDialog = true
      }
    },
    
    async logout() {
      try {
        await request.post('/logout', { token: this.token })
      } catch (error) {}
      this.token = ''
      this.username = ''
      this.content = ''
      this.editId = 0
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      this.$message.success('已退出登录')
    },
    
    async handleRegister() {
      this.$refs.registerForm.validate(async (valid) => {
        if (!valid) return
        this.registerLoading = true
        try {
          const res = await request.post('/register', {
            username: this.registerForm.username,
            password: this.registerForm.password,
            email: this.registerForm.email
          })
          if (res.data.code === 200) {
            this.$message.success('注册成功')
            this.showRegisterDialog = false
            this.username = this.registerForm.username
          } else {
            this.$message.error(res.data.msg)
          }
        } catch (error) {
          this.$message.error('注册失败')
        } finally {
          this.registerLoading = false
        }
      })
    },
    
    async handleChangePassword() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return
        this.changePasswordLoading = true
        try {
          const res = await request.post('/changePassword', {
            token: this.token,
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          })
          if (res.data.code === 200) {
            this.$message.success('修改成功')
            this.showChangePasswordDialog = false
            this.logout()
          } else {
            this.$message.error(res.data.msg)
          }
        } catch (error) {
          this.$message.error('修改失败')
        } finally {
          this.changePasswordLoading = false
        }
      })
    },
    
    formatDate(dateStr) {
      if (!dateStr) return ''
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr
      try {
        const d = new Date(dateStr)
        const y = d.getFullYear()
        const m = (d.getMonth() + 1).toString().padStart(2, '0')
        const d2 = d.getDate().toString().padStart(2, '0')
        return `${y}-${m}-${d2}`
      } catch (e) { return dateStr }
    },
    
    formatTime(timeStr) {
      if (!timeStr) return ''
      if (/^\d{2}:\d{2}(:\d{2})?$/.test(timeStr)) {
        return timeStr.length === 5 ? timeStr + ':00' : timeStr
      }
      try {
        if (timeStr.includes('T')) {
          const t = timeStr.split('T')[1].split(':')
          return `${t[0]}:${t[1]}:${t[2]?.substring(0,2) || '00'}`
        }
        return timeStr
      } catch (e) { return timeStr }
    },

    async login() {
      if (!this.username || !this.password) return this.$message.warning('请输入账号密码')
      this.loginLoading = true
      try {
        const res = await request.post('/login', { username: this.username, password: this.password })
        if (res.data.code === 200) {
          this.token = res.data.token
          localStorage.setItem('token', this.token)
          localStorage.setItem('username', this.username)
          this.getHistory()
          this.$message.success('登录成功')
        } else {
          this.$message.error(res.data.msg)
        }
      } catch (error) {
        this.$message.error('网络错误')
      } finally {
        this.loginLoading = false
      }
    },

    // 获取历史（三渠道自动加载）
    async getHistory() {
      this.historyLoading = true
      try {
        const res = await request.post('/history', {
          token: this.token,
          date: this.searchDate
        })
        this.allHistory.xiaodao = res.data.xiaodao || []
        this.allHistory.xingyue = res.data.xingyue || []
        this.allHistory.gbo = res.data.gbo || []
      } catch (error) {
        this.$message.error('获取历史记录失败')
        this.allHistory = { xiaodao: [], xingyue: [], gbo: [] }
      } finally {
        this.historyLoading = false
      }
    },

    // 提交：自动匹配接口
    async submit() {
      const check = this.validateContent(this.content)
      if (!check.valid) return this.$message.error(check.message)
      if (!this.selectDate || !this.selectTime) return this.$message.warning('请选日期时间')
      
      this.submitLoading = true
      try {
        const datetime = this.selectDate + 'T' + this.selectTime
        let api = ''
        
        if (this.currentChannel === 'xiaodao') api = '/submitXiaodao'
        else if (this.currentChannel === 'xingyue') api = '/submitXingyue'
        else if (this.currentChannel === 'gbo') api = '/submitGbo'
        
        const res = await request.post(api, {
          token: this.token,
          content: this.content,
          datetime
        })
        
        if (res.data.code === 200) {
          this.$message.success(`提交${this.getChannelName()}成功`)
          this.activeTab = this.currentChannel
          this.getHistory()
          this.content = ''
          this.selectTime = ''
        } else {
          this.$message.error(res.data.msg)
        }
      } catch (error) {
        this.$message.error('提交失败')
      } finally {
        this.submitLoading = false
      }
    },

    // 编辑
    toEdit(item) {
      this.editId = item.id
      this.currentChannel = this.activeTab
      this.editChannel = item.channel
      this.content = item.content
      this.selectDate = this.formatDate(item.submit_date)
      this.selectTime = item.submit_time ? item.submit_time.substring(0, 5) : ''
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    cancelEdit() {
      this.editId = 0
      this.editChannel = ''
      this.content = ''
      this.selectDate = getToday()
      this.selectTime = ''
    },

    // 保存编辑
    async saveEdit() {
      const check = this.validateContent(this.content)
      if (!check.valid) return this.$message.error(check.message)
      if (!this.selectDate || !this.selectTime) return this.$message.warning('请选日期时间')
      
      this.submitLoading = true
      try {
        const datetime = this.selectDate + 'T' + this.selectTime
        const res = await request.post('/edit', {
          token: this.token,
          id: this.editId,
          channel: this.editChannel,
          content: this.content,
          datetime
        })
        if (res.data.code === 200) {
          this.$message.success('修改成功')
          this.cancelEdit()
          this.getHistory()
        } else {
          this.$message.error(res.data.msg)
        }
      } catch (error) {
        this.$message.error('修改失败')
      } finally {
        this.submitLoading = false
      }
    },
    
    // 删除
    async handleDelete(item) {
      try {
        await this.$confirm('确定删除？', '提示', { type: 'warning' })
        this.deleteLoading = item.id
        const res = await request.post('/delete', {
          token: this.token,
          id: item.id,
          channel: item.channel
        })
        if (res.data.code === 200) {
          this.$message.success('删除成功')
          this.getHistory()
          if (this.editId === item.id) this.cancelEdit()
        } else {
          this.$message.error(res.data.msg)
        }
      } catch (error) {
      } finally {
        this.deleteLoading = null
      }
    }
  }
}
</script>

<style scoped>
/* 你的样式完全不变，我没动 */
* {
  box-sizing: border-box;
}

.login-wrap {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg,#f5e6ff,#e6e6ff 50%,#f0e6ff);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-box {
  max-width: 400px;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  padding: 32px 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  animation: fadeInUp 0.6s ease-out;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.login-header h2 {
  font-size: 28px;
  color: #333;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.login-header p {
  color: #888;
  font-size: 14px;
  margin: 0;
}

.login-input {
  margin-bottom: 20px;
}

.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: transform 0.2s, box-shadow 0.2s;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.register-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #667eea;
  cursor: pointer;
  transition: color 0.2s;
}

.register-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

.manage-box {
  max-width: 700px;
  width: 100%;
  margin: 0 auto;
  animation: fadeInUp 0.5s ease-out;
}

.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 50px;
  padding: 8px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.back-btn {
  border-radius: 40px;
  background: white;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
}

.back-btn:hover {
  background: #f5f7fa;
  transform: translateX(-2px);
}

.nav-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  background: linear-gradient(135deg, #667eea, #764ba2);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 20px;
  background: white;
  transition: background 0.2s;
}

.user-info:hover {
  background: #f0f2f5;
}

.user-info i {
  font-size: 16px;
  color: #667eea;
}

.username {
  font-size: 14px;
  color: #333;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card {
  background: white;
  border-radius: 24px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.content-textarea {
  margin-bottom: 16px;
}

.content-textarea >>> textarea {
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.6;
  resize: vertical;
}

.format-tip {
  background: #f0f7ff;
  border-radius: 12px;
  padding: 10px 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #409eff;
  border-left: 3px solid #409eff;
}

.format-tip i {
  font-size: 14px;
  flex-shrink: 0;
}

.datetime-group {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.datetime-picker {
  flex: 1;
  min-width: 140px;
}

.datetime-picker >>> .el-input__inner {
  border-radius: 12px;
}

.button-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.action-btn {
  flex: 1;
  min-width: 100px;
  height: 44px;
  border-radius: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.action-btn:hover {
  transform: translateY(-2px);
}

.search-date-picker {
  width: 160px;
}

.search-date-picker >>> .el-input__inner {
  border-radius: 20px;
  background: #f5f7fa;
}

.history-list {
  min-height: 200px;
}

.history-item {
  background: #f8f9fc;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.2s;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
}

.history-item:hover {
  background: #f0f2f6;
  transform: translateX(4px);
}

.edit-highlight {
  background: #fff7e6;
  border-left: 4px solid #e6a23c;
}

.history-content {
  flex: 1;
  font-size: 15px;
  font-weight: 500;
  color: #2c3e50;
  word-break: break-word;
  line-height: 1.5;
}

.history-time {
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.history-time i {
  margin-right: 4px;
}

.history-actions {
  display: flex;
  gap: 8px;
}

.empty-state {
  text-align: center;
  padding: 48px 20px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-text {
  font-size: 16px;
  color: #909399;
  margin-bottom: 8px;
}

.empty-hint {
  font-size: 13px;
  color: #c0c4cc;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .login-wrap {
    padding: 16px;
    align-items: flex-start;
    padding-top: 40px;
  }
  
  .login-box {
    padding: 24px 20px;
  }
  
  .login-header h2 {
    font-size: 24px;
  }
  
  .nav-bar {
    margin-bottom: 16px;
    padding: 6px 12px;
  }
  
  .back-btn {
    padding: 8px 12px;
  }
  
  .back-btn span {
    font-size: 13px;
  }
  
  .nav-title {
    font-size: 14px;
  }
  
  .user-info {
    padding: 4px 8px;
  }
  
  .username {
    font-size: 12px;
    max-width: 80px;
  }
  
  .card {
    padding: 20px;
    border-radius: 20px;
  }
  
  .card-title {
    font-size: 18px;
  }
  
  .datetime-group {
    flex-direction: column;
    gap: 12px;
  }
  
  .datetime-picker {
    width: 100%;
  }
  
  .button-group {
    flex-direction: column;
  }
  
  .action-btn {
    width: 100%;
  }
  
  .history-item {
    flex-direction: column;
    align-items: stretch;
  }
  
  .history-time {
    white-space: normal;
    justify-content: flex-start;
  }
  
  .history-actions {
    justify-content: flex-end;
  }
  
  .card-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-date-picker {
    width: 100%;
  }
  
  .format-tip {
    font-size: 11px;
    padding: 8px 12px;
  }
}

@media (max-width: 480px) {
  .manage-box {
    padding: 0;
  }
  
  .card {
    padding: 16px;
    margin-bottom: 16px;
  }
  
  .history-content {
    font-size: 14px;
  }
  
  .history-actions .el-button--mini {
    padding: 6px;
  }
  
  .format-tip {
    font-size: 10px;
  }
}
</style>